import { colors } from './types';

export const Colors: colors = {
  black: '#000000',
  lightGrayish: '#D5D5D5',
  lightGrey: '#EEEEEE',
  silver: '#DADADA',
  transparentBlack: '#00000026',
  veryLightGray: '#EFEFEF',
  white: '#FFFFFF',
  nearBlack: '#232323',
  semiTransparentBlack: '#00000040',
  platinumGray: '#E1E1E1',
  slateGray: '#87837826',
  silverGray: '#AEAEAE',
  lightSilver: '#C6C6C6',
  mediumGray: '#AAAAAA',
  warmGray: '#9A9A9A',
  charcoalGray: '#2E2E2E',
  ashGray: '#858585',
  electricBlue: '#0085FF',
  steelGray: '#999999',
  softGray: '#C5C5C5',
  doveGray: '#828282',
  skyBlue: '#0085FF',
  lightSlateGray: '#E4E4E4',
  midNightNavi: '#0C131D26',
};
